export const invitationUserAuth = {
    namespaced: true
};
